<template>
    <div class="flex flex-col p-8 border-b border-solid border-light category-offer-card">
        <div class="flex items-start">
            <div class="flex items-center justify-center mr-2 relative p-2">
                <img class="absolute object-cover w-full"
                src="@/assets/icons/offer-count-bg.svg"
                alt="offer-count-bg" />
                <span class="relative z-2 font-bold text-white">{{ index + 1 }}</span>
            </div>
            <div class="space-y-6" v-if="isEditing">
                <Input
                    label="Заголовок пункта:"
                    placeholder="Введите название"
                    classes="bg-hint w-110"
                    :invalid="$v.offer.description.$error"
                    v-model="offer.name"
                    />
                <Input
                    label="Описание пункта:"
                    :textarea="true"
                    placeholder="Введите описание пункта"
                    classes="w-150"
                    :invalid="$v.offer.description.$error"
                    v-model="offer.description"
                   />
                <div class="flex items-center justify-end">
                  <ButtonBorderless
                    class="mr-8"
                    @click.native="(e) => onCancelClick(e)">
                    Отменить
                  </ButtonBorderless>
                  <ButtonBorderless theme="green"
                  @click.native="(e) => onSaveClick(e)">Сохранить</ButtonBorderless>
                </div>
            </div>
            <div class="flex w-full justify-between"
            v-else-if="!isEditing && isOfferEmpty">
              <div class="flex flex-col" v-if="offer">
                <b class="text-sm mb-1">{{ offer.name }}</b>
                <span class="text-black opacity-75 whitespace-pre-line">
                  {{ offer.description }}</span>
              </div>
              <ButtonBorderless
              v-if="isEditDisabled"
              theme="blue"
              @click.native="(e) => onEditClick(e)">Редактировать</ButtonBorderless>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import Input from '@/components/Input.vue';
import { required } from 'vuelidate/lib/validators';
import ButtonBorderless from '@/components/ButtonBorderless.vue';

export default {
  components: {
    Input,
    ButtonBorderless,
  },
  data() {
    return {
      beforeEditingOffer: null,
      isEditing: this.editing ? this.editing : false,
    };
  },
  validations: {
    offer: {
      name: {
        required,
      },
      description: {
        required,
      },
    },
  },
  computed: {
    isOfferEmpty() {
      if (this.offer && !_.isEmpty(this.offer)) {
        return true;
      }
      return false;
    },
    ready() {
      return !this.$v.offer.$invalid;
    },
    computedBeforeEditingOffer: {
      get() {
        return this.offer;
      },
      set(newValue) {
        this.beforeEditingOffer = { ...newValue };
      },
    },
  },
  watch: {
    ready(val) {
      this.$emit('ready', val);
    },
  },
  props: {
    index: {
      type: Number,
      default: 1,
    },
    offer: {
      type: Object,
      default: () => {},
    },
    isEditDisabled: {
      type: Boolean,
      default: false,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    offers: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    touch() {
      this.$v.offer.$touch();
    },
    onEditClick(e) {
      this.beforeEditingOffer = { ...this.offer };
      if (!this.disabledEditing) {
        this.isEditing = !this.isEditing;
        this.$emit('offer-click', e, this.isEditing);
      }
    },
    onCancelClick(e) {
      if (this.beforeEditingOffer) {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          this.isEditing = !this.isEditing;
          this.$emit('offer-cancel', e, this.isEditing, this.beforeEditingOffer);
        }
      } else if (this.offers.length > 1) {
        this.$emit('new-offer-cancel', this.offer);
      }
    },
    onSaveClick(e) {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isEditing = !this.isEditing;
        this.$emit('offer-save', e, this.isEditing);
      }
    },
  },
};
</script>
